'use strict';

import { LogHelper } from 'com-gyf-webcore-loghelper';

import {
    INITIAL_STATE,
    EXPANDIR_ROW_CONFIRMADOR_AJUSTES_CARGOS,
    ABRIR_MODAL,
    CAMBIAR_ESTADO,
    ACTUALIZA_FECHA,
    FOMARTO_FECHA_MODAL_ESTADOS,
    GET_DATA_CONFIRMADOR,
    AGREGAR_USUARIO_MODAL_ESTADOS,
    ELIMINAR_USUARIO_MODAL_ESTADOS,
    DESTILDAR_TILDAR_CHECK_ALL_AJUSTE_CARGO,
    DESTILDAR_TILDAR_CHECK_AJUSTE_CARGO,
    GUARDAR_OBJ_FILTRADO,
    REINICIAR_MODAL_ESTADOS,
    DESTILDAR_TILDAR_CHECK,
    DESTILDAR_TILDAR_CHECK_ALL,
    LOADING_CONFIRMADOR,
    GET_DATA_AJUSTES_CARGOS_FILTRO,
    FILTRAR_MOVIMIENTOS_POR_DESCRIPCION,
    ACTUALIZAR_MARCA_TIPO_CUENTA,
    ACTUALIZAR_RADIOBTN_AJUSTE_CARGO,
    ACTUALIZAR_IMPORTE_SIN_IVA,
    ACTUALIZAR_TIPO_OPERACION,
    MOSTRAR_DATOS_GRILLA,
    LIMPIAR_PANEL_FILTROS,
    MOSTRAR_MODAL_CAMBIAR_ESTADO
} from '../../Screens/ConfirmadorAjusteCargo/actions/Actions';


/**
 * Estado inicial.
 */
const initialState = {
    rowSeleccionada: undefined,
    mostrarModalEstados: false,
    mostrarFiltrosCargoAjuste: false,
    mostrarModalErrorImportes: false,
    usuariosModalEstados: [],
    usuariosEstadoPendConfrimacion: [],
    usuariosEstadoDenegado: [],
    dataModalFiltrosCargoAjuste: [],
    idChecksAjusteCargoArray: [],
    movimientosFiltradosPorDescripcion: [],
    movimientosFiltradosParaMostrarPanel: [],
    marcas: undefined,
    marcaSeleccionada: undefined,
    rdButtonAjusteCargo: "A",
    tipoCuenta: undefined,
    tipoCuentaSeleccionada: undefined,
    ajusteCargocheckConfirmarAll: undefined,
    usuariosModalEstadosSeleccionado: undefined,
    objFiltradoBtnVer: undefined,
    mostrarLoading: false,
    tipoOperacion: {
        credito: false,
        debito: false,
    },
    importeSinIVA: {
        min: "",
        max: "",
        errorMin: false,
        errorMax: false
    },
    estadoSeleccionado: {
        esPendConfirmacion: true,
        esDenegado: false
    },
    fechasModalEstados: {
        desde: "",
        hasta: "",
        errorDesde: false,
        errorHasta: false
    },
    checkConfirmarArray: [],
    checkDenegarRestablecerArray: [],
    checkConfirmarAll: undefined,
    checkDenegarRestablecerAll: undefined,
    ajusteCargoIdArray: [],
    ajusteCargo: [],
    mostrarModalCambiarEstado: false,
    mostrarModalErrorCambiarEstado: false
};


function ConfirmadorAjusteCargo(state = initialState, action) {
    LogHelper.In(ConfirmadorAjusteCargo.name, state, action);

    let result;

    switch (action.type) {

        case INITIAL_STATE: {
                const newInit = JSON.parse(JSON.stringify(initialState));
                result = newInit;
            }
            break;

        case LOADING_CONFIRMADOR: {
            result = {
                ...state,
                mostrarLoading: action.valor
            };
            break;
        }

        case ACTUALIZAR_TIPO_OPERACION: {
            result = {
                ...state,
                tipoOperacion: {
                    ...state.tipoOperacion,
                    [action.campo]: action.valor
                }
            };
            break;
        }
        
        case ACTUALIZAR_MARCA_TIPO_CUENTA: {
            result = {
                ...state,
                [action.campo]: action.id
            };
            break;
        }

        case ACTUALIZAR_RADIOBTN_AJUSTE_CARGO: {
            result = {
                ...state,
                rdButtonAjusteCargo: action.valor
            };
            break;
        }

        case ACTUALIZAR_IMPORTE_SIN_IVA: {
            result = {
                ...state,
                importeSinIVA: {
                    ...state.importeSinIVA,
                    [action.campo]: action.valor,
                    [action.campoError]: action.errorFormato
                }
            };
            break;
        }

        case ABRIR_MODAL: {
            switch (action.modalId) {
                case 1: {
                    result = {
                        ...state,
                        mostrarModalEstados: action.muestraModal
                    };
                    break;
                }
                case 2: {
                    result = {
                        ...state,
                        mostrarFiltrosCargoAjuste: action.muestraModal
                    };
                    break;
                }
                case 3: {
                    result = {
                        ...state,
                    };
                    break;
                }
                case 4: {
                    result = {
                        ...state,
                    };
                    break;
                }
                case 5: {
                    result = {
                        ...state,
                        mostrarModalErrorImportes: action.muestraModal
                    };
                    break;
                }
                case 6: {
                    result = {
                        ...state,
                        mostrarModalErrorCambiarEstado: action.muestraModal
                    };
                    break;
                }
            }
            break;
        }

        case CAMBIAR_ESTADO: {

            result = {
                ...state,
                estadoSeleccionado: {
                    esPendConfirmacion: action.seleccionoPendConfirmacion,
                    esDenegado: action.seleccionoDenegado
                },
                fechasModalEstados: {
                    ...state.fechasModalEstados,
                    desde: action.fechaEstadoDenegado,
                    hasta: action.fechaEstadoPendConfirmacion
                }
            };
            break;
        }

        case ACTUALIZA_FECHA: {
            result = {
                ...state,
                fechasModalEstados: {
                    ...state.fechasModalEstados,
                    [action.campo]: action.valor
                }
            };
            break;
        }

        case FOMARTO_FECHA_MODAL_ESTADOS: {
            result = {
                ...state,
                fechasModalEstados: {
                    ...state.fechasModalEstados,
                    [action.errorCampo]: action.valor
                }
            };
            break;
        }

        case GET_DATA_CONFIRMADOR: {
            result = {
                ...state,
                usuariosEstadoPendConfrimacion: action.usuariosEstadoPendConfrimacion,
                usuariosEstadoDenegado: action.usuariosEstadoDenegado,
                marca: action.marca,
                tipoCuenta: action.tipoCuenta,
                ajusteEstados: action.ajusteEstados,
                cargoEstados: action.cargoEstados,
                objFiltradoBtnVer: action.objFiltrado
            };
            break;
        }

        case GET_DATA_AJUSTES_CARGOS_FILTRO: {
            result = {
                ...state,
                dataModalFiltrosCargoAjuste: action.dataModalFiltrosCargoAjuste,
                movimientosFiltradosPorDescripcion: action.dataModalFiltrosCargoAjuste
            };
            break;
        }

        case LIMPIAR_PANEL_FILTROS: {
            result = {
                ...state,
                movimientosFiltradosParaMostrarPanel: [],
                idChecksAjusteCargoArray:[],
                ajusteCargocheckConfirmarAll: undefined
            };
            break;
        }

        case FILTRAR_MOVIMIENTOS_POR_DESCRIPCION: {
            state.movimientosFiltradosPorDescripcion = action.movimientosEncontrados;

            result = {
                ...state,
                movimientosFiltradosPorDescripcion: state.movimientosFiltradosPorDescripcion
            };
            break;
        }

        case DESTILDAR_TILDAR_CHECK_AJUSTE_CARGO: {

            if (action.estadoCheck) {
                let index = state.idChecksAjusteCargoArray.indexOf(action.movimientoId);
                if (index > -1) {
                    state.idChecksAjusteCargoArray.splice(index, 1);
                }
                result = {
                    ...state,
                    idChecksAjusteCargoArray: [...state.idChecksAjusteCargoArray],
                    movimientosFiltradosParaMostrarPanel: [...action.arrayAuxPanel]
                };
            } else {
                result = {
                    ...state,
                    idChecksAjusteCargoArray: [...state.idChecksAjusteCargoArray, action.movimientoId],
                    movimientosFiltradosParaMostrarPanel: [...state.movimientosFiltradosParaMostrarPanel, action.objAuxPanel],
                };
            }
            break;
        }

        case DESTILDAR_TILDAR_CHECK_ALL_AJUSTE_CARGO: {

            result = {
                ...state,
                ajusteCargocheckConfirmarAll: action.checkConfirmar,
                idChecksAjusteCargoArray: action.checkConfirmar ? [...action.idChecksAjusteCargoArray] : [],
                movimientosFiltradosParaMostrarPanel: action.checkConfirmar ? [...action.dataFiltrosCargoAjuste] : [],
            };
            break;
        }

        case AGREGAR_USUARIO_MODAL_ESTADOS: {

            let usuariosEstado = state.estadoSeleccionado.esPendConfirmacion ? state.usuariosEstadoPendConfrimacion : state.usuariosEstadoDenegado;
            let usuarioSelecionado = action.login ? usuariosEstado.find(x => x.Login == action.login) : undefined;

            result = {
                ...state,
                usuariosModalEstadosSeleccionado: usuarioSelecionado
            };
            break;
        }

        case ELIMINAR_USUARIO_MODAL_ESTADOS: {
            result = {
                ...state,
                usuariosModalEstadosSeleccionado: undefined
            };
            break;
        }

        case GUARDAR_OBJ_FILTRADO: {
            result = {
                ...state,
                objFiltradoBtnVer: action.objFiltrado
            };
            break;
        }

        case REINICIAR_MODAL_ESTADOS: {
            result = {
                ...state,
                usuariosModalEstadosSeleccionado: undefined,
                objFiltradoBtnVer: undefined,
                estadoSeleccionado: {
                    esPendConfirmacion: true,
                    esDenegado: false
                },
                fechasModalEstados: {
                    desde: "",
                    hasta: "",
                    errorDesde: false,
                    errorHasta: false
                }
            };
            break;
        }

        case EXPANDIR_ROW_CONFIRMADOR_AJUSTES_CARGOS: {
            let id = undefined;

            if (state.rowSeleccionada != action.id) {
                id = action.id
            }

            result = {
                ...state,
                rowSeleccionada: id
            };
        }
            break;

        case DESTILDAR_TILDAR_CHECK: {
            //Si estado = true, quiere decir que el check está tildado, entonces el action activado por el Onclick es de "destildar"
            if (action.estado) {
                let index = undefined;
                let checkConfirmarArrayAux = state.checkConfirmarArray;
                let checkDenegarRestablecerArrayAux = state.checkDenegarRestablecerArray;

                if (action.checkConfirmarId) {
                    index = checkConfirmarArrayAux.indexOf(action.checkConfirmarId);

                    if (index > -1) {
                        checkConfirmarArrayAux.splice(index, 1);
                    }
                } else {
                    index = checkDenegarRestablecerArrayAux.indexOf(action.checkDenegarRestablecerId);

                    if (index > -1) {
                        checkDenegarRestablecerArrayAux.splice(index, 1);
                    }
                }

                checkConfirmarArrayAux = checkConfirmarArrayAux.filter(check => check)
                checkDenegarRestablecerArrayAux = checkDenegarRestablecerArrayAux.filter(check => check)

                result = {
                    ...state,
                    checkConfirmarArray: checkConfirmarArrayAux,
                    checkDenegarRestablecerArray: checkDenegarRestablecerArrayAux,
                    checkConfirmarAll: undefined,
                    checkDenegarRestablecerAll: undefined
                };
            }
            else {
                let index = undefined;
                let id = undefined;
                let checkConfirmarArrayAux = state.checkConfirmarArray;
                let checkDenegarRestablecerArrayAux = state.checkDenegarRestablecerArray;

                //Si tildo un check, aseguro de que el otro checkbox quede destildado
                if (action.checkConfirmarId) {
                    id = action.checkConfirmarId
                    
                    index = checkDenegarRestablecerArrayAux.indexOf(id);

                    if (index > -1) {
                        checkDenegarRestablecerArrayAux.splice(index, 1);
                    }
                } else {
                    id = action.checkDenegarRestablecerId
                    index = checkConfirmarArrayAux.indexOf(id);

                    if (index > -1) {
                        checkConfirmarArrayAux.splice(index, 1);
                    }
                }

                checkConfirmarArrayAux.push(action.checkConfirmarId);
                checkDenegarRestablecerArrayAux.push(action.checkDenegarRestablecerId);

                checkConfirmarArrayAux = checkConfirmarArrayAux.filter(check => check)
                checkDenegarRestablecerArrayAux = checkDenegarRestablecerArrayAux.filter(check => check)

                result = {
                    ...state,
                    checkConfirmarArray: checkConfirmarArrayAux,
                    checkDenegarRestablecerArray: checkDenegarRestablecerArrayAux,
                    checkConfirmarAll: undefined,
                    checkDenegarRestablecerAll: undefined
                };
            }
        }
            break;

        case DESTILDAR_TILDAR_CHECK_ALL: {
            let auxCheckConfirmarArray = state.checkConfirmarArray
            let auxCheckDenegarRestablecerArray =state.checkDenegarRestablecerArray

            auxCheckConfirmarArray = action.checkConfirmar ? [...action.ajusteCargoIdArray] : [],
            auxCheckDenegarRestablecerArray = action.checkDenegarRestablecer ? [...action.ajusteCargoIdArray] : []
            result = {
                ...state,
                checkConfirmarAll: action.checkConfirmar,
                checkDenegarRestablecerAll: action.checkDenegarRestablecer,
                checkConfirmarArray: auxCheckConfirmarArray,
                checkDenegarRestablecerArray: auxCheckDenegarRestablecerArray
            };
        }
            break;

        case MOSTRAR_DATOS_GRILLA: {
            result = {
                ...state,
                ajusteCargo: action.ajusteCargo
            };
        }
        break;

        case MOSTRAR_MODAL_CAMBIAR_ESTADO: {
            result = {
                ...state,
                mostrarModalCambiarEstado: action.mostrarModalCambiarEstado
            };
        }
        break;

        default:
            result = {
                ...state
            };
            break;
    }

    LogHelper.Out(ConfirmadorAjusteCargo.name, result);
    return result;
}


export default ConfirmadorAjusteCargo;